import React from "react";
import { motion, AnimatePresence } from 'framer-motion';
import { Map, MapPinned, FileCode } from "lucide-react";
import { LocationCascadeSearch } from "./LocationCascadeSearch";
import { MultiStateSelector } from "./MultiStateSelector";

export const ScopeSection = ({
  scope,
  onScopeChange,
  selectedLocations,
  onLocationsChange,
  selectedStates,
  onStatesChange,
  geometryValue,
  onGeometryChange
}) => {
  
  return (
    <div className="space-y-10">
      <div className="flex gap-4 p-2 bg-green-50/30 rounded-[2rem] border-2 border-green-50">
        {[
          { id: 'state', label: 'ADMINISTRATIVE BOUNDARY', icon: Map },
          { id: 'custom', label: 'CUSTOM BOUNDARY', icon: MapPinned }
        ].map((option) => (
          <button
            key={option.id}
            onClick={() => onScopeChange({ target: { value: option.id } })}
            className={`flex-1 py-5 rounded-[1.5rem] font-black text-[13.5px] uppercase tracking-[0.2em] transition-all flex items-center justify-center gap-3 border
              ${scope === option.id 
                ? 'bg-green-600 text-white border-green-600 shadow-lg shadow-green-300/70' 
                : 'bg-green-50 text-green-700 border-black/5 shadow-md shadow-green-200/80 hover:shadow-lg hover:shadow-green-300/70 hover:bg-green-100'}`}
          >
            <option.icon size={16} />
            {option.label}
          </button>
        ))}
      </div>

      <AnimatePresence mode="wait">
        <motion.div
          key={scope}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.3 }}
          className="space-y-8"
        >
          {scope === "state" && (
            <div className="p-8 rounded-[2.5rem] bg-white border border-slate-200 shadow-[0_10px_30px_-12px_rgba(15,23,42,0.18)]">
              <div className="mb-6">
                <h4 className="text-[14px] font-black text-gray-800 uppercase tracking-widest flex items-center gap-2">
                  Administrative Hierarchy
                </h4>
                <p className="text-[12px] font-bold text-gray-600 mt-1 uppercase">Select specific regions or municipalities</p>
              </div>
              <LocationCascadeSearch
                selectedLocations={selectedLocations}
                onLocationsChange={onLocationsChange}
              />
            </div>
          )}

          {scope === "custom" && (
            <div className="space-y-8">
              <div className="p-8 rounded-[2.5rem] bg-white border border-slate-200 shadow-[0_10px_30px_-12px_rgba(15,23,42,0.18)]">
                <div className="mb-6">
                  <h4 className="text-[14px] font-black text-gray-800  uppercase tracking-widest flex items-center gap-2">
                    State Association
                  </h4>
                  <p className="text-[12px] font-bold text-gray-600 mt-1 uppercase">Link this custom area to official states</p>
                </div>
                <MultiStateSelector
                  selectedStates={selectedStates}
                  onChange={onStatesChange}
                />
              </div>

              <div className="space-y-4">
                <label className="flex items-center gap-2 text-[12px] font-black text-gray-600 uppercase tracking-[0.2em] px-1">
                  <FileCode size={14} className="text-green-500" />
                  WKT Geometry Definition
                </label>
                <textarea
                  value={geometryValue}
                  onChange={(e) => onGeometryChange(e.target.value)}
                  placeholder="POLYGON((...))"
                  className="w-full p-6 rounded-[2rem] border-2 transition-all outline-none text-xs font-mono font-bold min-h-[120px]"
                />
              </div>
            </div>
          )}
        </motion.div>
      </AnimatePresence>
    </div>
  );
};
